<div class="find-account-container">
  <div class="find-account-card">
    <div class="logo-header">
      <img [src]="logoPath" alt="Nevada Department of Education Logo" class="nevada-logo" id="nevada-logo">
    </div>

    <div class="horizontal-line"></div>

    <div class="content-section">
      <div class="header-content">
        <h1>Find Your Account</h1>
        <p class="subtitle">
          Enter the phone number associated with your account. We'll send a one-time verification code via SMS.
        </p>
      </div>

      <form [formGroup]="findAccountForm" (ngSubmit)="onSubmit()">
        <div class="text-field">
          <div class="label-container">
            <label for="phone" class="label" style="white-space: nowrap;">
              Phone Number<span class="requiredfield text-danger">*</span>
            </label>
          </div>
          <div class="input-container">
            <input type="tel" id="phone" formControlName="phone" placeholder="Enter Phone Number"
              [ngClass]="{'is-invalid': isSubmitted && formControls['phone'].errors}" maxlength="17"
              allowOnlyNumbers (input)="formatPhoneNumber($event)">
            <div *ngIf="(isSubmitted || formControls['phone'].touched) && formControls['phone'].errors"
              class="error-message1">
              <span *ngIf="formControls['phone'].errors?.['required']">Please enter your phone number.</span>
              <span *ngIf="formControls['phone'].errors?.['pattern']">Please enter a valid phone number.</span>
            </div>
          </div>
        </div>

        
        <div class="action-buttons">
          <button class="cstmBtn cancel-btn" id="btn_forgot-password-phone_cancel" (click)="cancel()">Cancel</button>
          <button type="submit" class="cstmBtn cta-button" id="btn_forgot-password-phone_submit" [disabled]="isButtonDisabled" (click)="getToastMessage()">
            <span class="button-text">Send Code</span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="toast-message" id="toast_message" *ngIf="showToastDiv"
   [ngClass]="{
    'toast-message-success' : toastType === true,
    'toast-message-failed' : toastType === false}">
    <div class="success-icon">
            <img [src]="toastType === true ? 'assets/images/cardy-ai/tick icon.png' : 'assets/images/cardy-ai/window-close-icon-white.svg' " alt="toastIcon">
    </div>
    <p>{{toastMessage}}</p>
  </div>
</div>